/**
 * User Service
 * 
 * API service for user profile management
 */

import { apiClient } from './apiService';

/**
 * Get user profile by ID
 */
export const getUserById = async (userId) => {
  try {
    const response = await apiClient.get(`/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};

/**
 * Get user profile by email
 */
export const getUserByEmail = async (email) => {
  try {
    const response = await apiClient.get(`/users/email/${email}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user by email:', error);
    throw error;
  }
};

/**
 * Create a new user profile
 */
export const createUser = async (userData) => {
  try {
    const response = await apiClient.post('/users/', userData);
    return response.data;
  } catch (error) {
    console.error('Error creating user profile:', error);
    throw error;
  }
};

/**
 * Update user profile
 */
export const updateUser = async (userId, updateData) => {
  try {
    const response = await apiClient.put(`/users/${userId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};

/**
 * Delete user profile
 */
export const deleteUser = async (userId) => {
  try {
    await apiClient.delete(`/users/${userId}`);
    return true;
  } catch (error) {
    console.error('Error deleting user profile:', error);
    throw error;
  }
};

/**
 * List all users (with pagination)
 */
export const listUsers = async (skip = 0, limit = 100) => {
  try {
    const response = await apiClient.get('/users/', {
      params: { skip, limit }
    });
    return response.data;
  } catch (error) {
    console.error('Error listing users:', error);
    throw error;
  }
};

/**
 * Update last login timestamp
 */
export const updateLoginTimestamp = async (userId) => {
  try {
    const response = await apiClient.post(`/users/${userId}/login`);
    return response.data;
  } catch (error) {
    console.error('Error updating login timestamp:', error);
    throw error;
  }
};

/**
 * Get current user (placeholder for future authentication)
 * For now, returns first user or creates a demo user
 */
export const getCurrentUser = async () => {
  try {
    const users = await listUsers(0, 1);
    
    if (users && users.length > 0) {
      return users[0];
    }
    
    // Create demo user if none exists
    const demoUser = {
      first_name: "Alexander",
      last_name: "Schmidt",
      email: "alexander.schmidt@example.com",
      phone: "+49 30 12345678",
      username: "alexschmidt",
      job_title: "Data Engineer",
      company_name: "Tech Solutions GmbH",
      department: "Engineering",
      company_website: "https://techsolutions.de",
      bio: "Experienced data engineer with a passion for web scraping and automation. Specialized in building scalable data pipelines and AI-powered solutions.",
      address: {
        street: "Friedrichstraße 123",
        city: "Berlin",
        postal_code: "10117",
        state: "Berlin",
        country: "Germany"
      },
      social_links: {
        linkedin: "",
        github: "",
        twitter: "",
        website: ""
      },
      preferences: {
        language: "English (US)",
        timezone: "Europe/Berlin (GMT+1)",
        date_format: "DD/MM/YYYY",
        currency: "EUR (€)"
      },
      privacy_settings: {
        profile_public: true,
        show_email: false,
        show_activity: true,
        allow_indexing: true
      },
      plan: "Pro",
      credits_remaining: 12450,
      storage_used: 3.2,
      api_keys_count: 3
    };
    
    return await createUser(demoUser);
    
  } catch (error) {
    console.error('Error getting current user:', error);
    throw error;
  }
};

